module.exports = __webpack_public_path__ + "static/grow_business-1626f0abeb0c14d79d1edcfd7d0ba191.png";